import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import GetDirection from './views/Get.vue'

export const DirectionRoutes = [
  {
    path: '/directions',
    name: 'ListDirection',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'direction:list'
    }
  },
  {
    path: '/direction',
    name: 'CreateDirection',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'direction:create'
    }
  },
  {
    path: '/direction/:id',
    name: 'UpdateDirection',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'direction:update'
    }
  },
  {
    path: '/direction/view/:id',
    name: 'GetDirection',
    component: GetDirection,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'direction:get'
    }
  }
]
